import styled from "styled-components";

type IFunnelNavPanelContainerProps = {
};

export const $FunnelNavPanelContainer = styled.div<IFunnelNavPanelContainerProps>`
  font-family: "Open Sans";
`;
